import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getPostsResumos } from "../../services/servicesGetPostsResumos";
import { IsTrialVersion } from "../../services/servicesIsTrialVersion";
import { GetPostsLeft } from "../../services/servicesGetPostsLeft";
import { Subscribe } from "../../services/servicesSubscribe";
import { getSubscribeInfo } from "../../services/servicesGetSubscribeInfo";
import {
    DivPrincipal,
    TituloCategoria,
    DivCategoria,
    DivHome,
    DivPost,
    DivIcon,
    SpanSeeAll,
    DivTitle,
    DivPopupTakePhone,
} from "./stylesHome";
import {
    P,
    Option,
    Divoption,
    Button,
    SpanButton,
} from "../postEdit/stylePostEdit";
import { IconFaLessThan, IconFaGreaterThan } from "./stylesHome";
import { URLIMG } from "../../helpers/constantes";
import Popup from "reactjs-popup";
import LoadScreenSmall from "../../components/loadScreenSmall/loadScreenSmall";
import ButtonTrialVersion from "../../components/ButtonTrialVersion/ButtonTrialVersion";
import Toastify from "../../components/Toastify";
import "../../GlobalStyle";
import { Input } from "../../styles/CommonStyles";

function Home() {
    const history = useHistory();
    const location = useLocation();

    const scrollRef = useRef([]);

    const [posts, setPosts] = useState([]);
    const [leftPost, setLeftPost] = useState(false);
    const [renovacao, setRenovacao] = useState(false);
    const [qntdPostLeft, setQntdPostLeft] = useState("");
    const [urlimg, setUrlImg] = useState(URLIMG);
    const [smallScreen, setSmallScreen] = useState(false);
    const [isTrial, setIsTrial] = useState(false);
    const [price, setPrice] = useState({});
    const [showCategory, setShowCategory] = useState([]);
    const [showDivScroll, setShowDivScroll] = useState([]);
    const [lockDiv, setLockDiv] = useState(false);
    const [mobile, setMobile] = useState(false);
    const [initialValue, setInitialValue] = useState("");
    const [takePhone, setTakePhone] = useState(false);
    const message1 = `Investimento de R$${new Number(
        price.PlanCurrentPrice
    ).toLocaleString("pt-BR")},00 (12x de R$${new Number(
        price.PlanCurrentPrice / 12
    ).toLocaleString("pt-BR")},00) para 30 conteúdos por mês`;
    const message2 = (
        <>
            Investimento de{" "}
            <s>R${new Number(price.PlanPrice).toLocaleString("pt-BR")},00</s>{" "}
            por R${new Number(price.PlanCurrentPrice).toLocaleString("pt-BR")}
            ,00 (12x de R$
            {new Number(price.PlanCurrentPrice / 12).toLocaleString("pt-BR")}
            ,00)
            <br /> para ter acesso à 30 conteúdos por mês
        </>
    );

    async function subscribeInfo() {
        const data = await getSubscribeInfo();
        setPrice({
            PlanCurrentPrice: data.data.PlanCurrentPrice,
            PlanPrice: data.data.PlanPrice,
        });
    }

    async function carregaPosts() {
        const posts = await getPostsResumos();
        setPosts(posts);
    }

    async function VerificaTrial() {
        const trial = await IsTrialVersion();

        if (trial) {
            setIsTrial(true);
            setTakePhone(true);
            localStorage.setItem("ticketLink", "teste");
        } else {
            if (localStorage.getItem("ticketLink"))
                localStorage.removeItem("ticketLink");
        }
    }

    async function VerificarQuantidadePostRestante() {
        const postsAmount = await GetPostsLeft();
        if (postsAmount <= 0) {
            await subscribeInfo();
            setRenovacao(true);
        } else {
            if (localStorage.getItem("ticketLink"))
                localStorage.removeItem("ticketLink");
        }
    }

    async function generateTicket() {
        setSmallScreen(true);
        const ticketLink = await Subscribe();
        window.location.href = `${ticketLink}&redirectURL=https://social.medx.med.br/payment-success`;
        setRenovacao(false);
        setSmallScreen(false);
    }
    function redirectURL({ pathname, state }) {
        history.push(pathname);
        location.pathname = pathname;
    }

    function scrollingRight(element, elementScrollLeft) {
        element.scrollLeft = elementScrollLeft + 900;
    }
    function scrollingLeft(element, elementScrollLeft) {
        element.scrollLeft = elementScrollLeft - 900;
    }

    function showAllPostCategory(index) {
        setShowCategory((oldValue) => {
            let array = [];
            array[index] = true;
            return array;
        });
    }

    function hideAllPostCategory(index) {
        setShowCategory((oldValue) => {
            let array = [];
            array[index] = false;
            return array;
        });
    }

    function Values({ pageX, pageY, screenX, screenY }) {
        this.pageX = pageX;
        // this.pageY = pageY;
        this.screenX = screenX;
        // this.screenY = screenY;
    }

    function lockDivInitialValue(event) {
        setInitialValue(event.screenX);
        setLockDiv(true);
    }

    function unlockDivZeroInitialValue() {
        setInitialValue(0);
        setLockDiv(false);
    }

    function moveDiv(event, pageElement, pageElementScrollLeft) {
        if (lockDiv) {
            if (event.screenX < initialValue) {
                pageElement.scrollLeft =
                    pageElementScrollLeft - (initialValue - event.screenX);
                console.log("movendo para esquerda");
            } else console.log("movendo para direita");
        }
    }

    function mobileCheck() {
        let check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    useEffect(() => {
        VerificaTrial();
        carregaPosts();
        VerificarQuantidadePostRestante();
        let mobile = mobileCheck();
        if (mobile) {
            setMobile(true);
        }
    }, []);

    function carregatitulo(title) {
        console.log(title);
    }

    const postsOrganizados = useMemo(() => {
        let lista = {};
        if (posts != null) {
            posts.forEach((item) => {
                if (lista[item.Category]) {
                    lista[item.Category].push(item);
                } else {
                    lista[item.Category] = [item];
                }
            });
            let arrayLista = [];

            for (const key in lista) {
                if (lista.hasOwnProperty(key)) {
                    arrayLista.push(lista[key]);
                }
            }
            return arrayLista;
        }

        return null;
    }, [posts]);

    return postsOrganizados ? (
        <DivHome>
            {isTrial ? <ButtonTrialVersion /> : ""}
            {postsOrganizados.map((item, index) => {
                //item é o array organizado
                return (
                    <DivPrincipal
                        key={index}
                        onMouseOver={() =>
                            setShowDivScroll((oldValue) => {
                                let array = [];
                                array[index] = true;
                                return array;
                            })
                        }
                        onMouseOut={() =>
                            setShowDivScroll((oldValue) => {
                                let array = [];
                                array[index] = false;
                                return array;
                            })
                        }
                    >
                        <DivTitle
                            onMouseOver={() => showAllPostCategory(index)}
                            onMouseOut={() => hideAllPostCategory(index)}
                            onClick={() =>
                                redirectURL({
                                    pathname: `/app/categoria/${item[index].Category}`,
                                })
                            }
                        >
                            <TituloCategoria>
                                <nobr>
                                    {" "}
                                    {item[index].Category === "Exclusivos"
                                        ? "Não publicados"
                                        : item[index].Category === "Populares"
                                        ? "Mais Compartilhados"
                                        : item[index].Category}
                                </nobr>
                            </TituloCategoria>
                            <SpanSeeAll showCategory={true}>
                                <span>Ver Tudo</span>
                                <IconFaGreaterThan
                                    minimum={"true"}
                                    style={{ display: true ? "unset" : "none" }}
                                />
                            </SpanSeeAll>
                        </DivTitle>
                        {/* onScroll={(event)=>console.table(new Values(event.currentTarget))} */}
                        <DivCategoria
                            ref={(item) => (scrollRef.current[index] = item)}
                            onMouseDown={(event) => lockDivInitialValue(event)}
                            onMouseUp={unlockDivZeroInitialValue}
                            // onMouseMove={(event)=>moveDiv(event,scrollRef.current[index],scrollRef?.current[index]?.scrollLeft)}
                        >
                            <DivIcon
                                show={true}
                                activeLeft={true}
                                onClick={() =>
                                    scrollingLeft(
                                        scrollRef.current[index],
                                        scrollRef?.current[index]?.scrollLeft
                                    )
                                }
                                mobile={mobile}
                            >
                                <IconFaLessThan />
                            </DivIcon>
                            {item.map((item) => {
                                //map de todos os posts, separado pela categoria
                                return (
                                    <DivPost key={item.Id}>
                                        <img
                                            id={item.Id}
                                            onClick={() =>
                                                redirectURL({
                                                    pathname: `/app/postedit/${item.Id}`,
                                                    state: item.Id,
                                                })
                                            }
                                            alt=""
                                            src={`${
                                                urlimg +
                                                item.Image1.split("/")[
                                                    item.Image1.split("/")
                                                        .length - 1
                                                ]
                                            }`}
                                        />
                                    </DivPost>
                                );
                            })}
                            <DivIcon
                                show={true}
                                activeRight={true}
                                onClick={() =>
                                    scrollingRight(
                                        scrollRef.current[index],
                                        scrollRef.current[index].scrollLeft
                                    )
                                }
                                mobile={mobile}
                            >
                                <IconFaGreaterThan />
                            </DivIcon>
                        </DivCategoria>
                    </DivPrincipal>
                );
            })}
            <Popup
                open={renovacao}
                onClose={() => setRenovacao(false)}
                contentStyle={{
                    height: "content-fit",
                    width: "content-fit",
                    borderRadius: "4px",
                    padding: "10px",
                }}
                modal
                closeOnDocumentClick={false}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: "35px",
                    }}
                >
                    <P style={{ margin: "0" }}>Sua quantidade de posts é: 0</P>
                    <P style={{ margin: "0" }}>
                        Deseja renovar a contratação anual do serviço ?<br />{" "}
                        {price.PlanCurrentPrice === price.PlanPrice
                            ? message1
                            : message2}
                    </P>
                    <Divoption style={{ marginTop: "15px" }}>
                        <Option onClick={generateTicket}>Sim</Option>
                        <Option
                            onClick={() => {
                                setRenovacao(false);
                            }}
                        >
                            Não
                        </Option>
                    </Divoption>
                </div>
            </Popup>
            <Popup
                open={takePhone}
                onClose={() => setTakePhone(false)}
                closeOnDocumentClick={false}
                contentStyle={{
                    borderRadius: "6px",
                    padding: "10px",
                    width: "100vw",
                }}
            >
                <DivPopupTakePhone>
                    <P>
                        Gostaria de agendar uma demonstração do sistema ? <br />{" "}
                        Informe abaixo um telefone para que possamos entrar em
                        contato
                    </P>
                    <Input placeholder="Insira aqui seu telefone" />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            margin: "16px 0 0 0",
                            width: "100%",
                        }}
                    >
                        <Button
                            onClick={() => Toastify.warning("Implementar API")}
                        >
                            <SpanButton>Quero</SpanButton>
                        </Button>
                        <Button onClick={() => setTakePhone(false)}>
                            <SpanButton>Não, obrigado.</SpanButton>
                        </Button>
                    </div>
                </DivPopupTakePhone>
            </Popup>
            {smallScreen ? (
                <LoadScreenSmall open={smallScreen} close={setSmallScreen} />
            ) : (
                <></>
            )}
        </DivHome>
    ) : (
        <div>
            <DivPrincipal>
                <TituloCategoria>
                    <nobr> Vazio </nobr>
                </TituloCategoria>
                <DivCategoria></DivCategoria>
            </DivPrincipal>
        </div>
    );
}

export default Home;
